<form autocomplete="off" [formGroup]="enterDetailsForm" class="checkout-form">
	<app-checkout-enter-details-form
		[form]="enterDetailsForm"
	></app-checkout-enter-details-form>
</form>
